import { globalServices } from "../Axios/GlobalService";
import { ServiceUrl } from "../Helpers/Constants";
import { AuthenticationResponse } from "../Interfaces/AuthenticationResponse";
import { actionLogOut } from "../Redux/Slices/userSlice";
import { store } from "../Redux/store";

export const AuthenticationService = {
    login,
    logout
}

interface LoginModel {
    username: string;
    password: string;
}

function login(username: string, password: string) {
    const loginmodel: LoginModel = {
        username: username,
        password: password,
    };
    return globalServices.postAuth<AuthenticationResponse>(
        `${ServiceUrl}Authentication/authenticate`,
        loginmodel
    );
}
function logout() {
    store.dispatch(actionLogOut());
}